module.exports = "img/flags/CC.9b5f975.png";